// Function to format numbers as currency (TZS in this case) without cents
const formatCurrency = (amount, locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export default formatCurrency;
